const POSITION = 'top';

export default {
    namespaced: true,
    state: {
        message: '',
        trigger: '',
        position: POSITION,
        class: '',
    },
    getters: {
        get(state) {
            if (!state.message || !state.trigger) return false;

            return state;
        },
    },
    mutations: {
        set(state, { message, trigger, position, class: tooltipClass }) {
            state.message = message;
            state.trigger = trigger;
            state.position = position || POSITION;
            state.class = tooltipClass || "";
        },
        clear(state) {
            state.message = '';
            state.trigger = '';
            state.position = POSITION;
            state.class = "";
        }
    },
    actions: {}
}